export const deleteFromFilterArrayHandler = (
  state: any,
  actionPayload: IReduxPayloadProps
) => {
  const [payloadKey, payloadValue] = Object.entries(actionPayload)[0];
  const index = state[payloadKey].indexOf(payloadValue);

  if (index === -1) {
    return state;
  }

  const sliceValues = [
    ...state[payloadKey].slice(0, index),
    ...state[payloadKey].slice(index + 1),
  ];

  return {
    ...state,
    [payloadKey]: sliceValues,
    ...(state.filterCount && { filterCount: state.filterCount - 1 }),
  };
};

export type IReduxPayloadProps = {
  [key: string]: any;
};

export interface IReduxActionProps {
  type: string;
  payload?: IReduxPayloadProps;
}
